import get from 'lodash/fp/get'

import { RootState } from '../../../store/root.reducer'

export const getLoggedUserUsername = (state: RootState) => get('keycloak.tokenParsed.preferred_username', state)
export const getLoggedUserEmail = (state: RootState) => get('keycloak.tokenParsed.email', state)
export const getLoggedUserFirstName = (state: RootState) => get('keycloak.tokenParsed.given_name', state)
export const getLoggedUserSurname = (state: RootState) => get('keycloak.tokenParsed.family_name', state)
export const getTokenUUID = (state: RootState) => get('keycloak.tokenParsed.uuid', state)
export const getTokenId = (state: RootState) => get('keycloak.tokenParsed.id', state)
export const getAuthenticated = (state: RootState) => get('keycloak.authenticated', state)
export const getRealm = (state: RootState) => state.keycloak.realm
